import { useTranslation } from "react-i18next";
// components
import { useSettingsContext } from "../components/settings";
//
import { allLangs, defaultLang } from "./config";

import { nl, enUS } from "date-fns/locale";
import { useCallback } from "react";

const dateFnsLocaleMap = {
  nl: nl,
  en: enUS,
};

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();
  const { onChangeDirectionByLang } = useSettingsContext();

  const currentLang =
    allLangs.find((_lang) => _lang.value === i18n.language) || defaultLang;

  const handleChangeLanguage = useCallback(
    (newlang) => {
      i18n.changeLanguage(newlang);
      onChangeDirectionByLang(newlang);
    },
    [i18n, onChangeDirectionByLang]
  );

  return {
    onChangeLang: handleChangeLanguage,
    translate: (text, options) => translate(text, options),
    currentLang,
    allLangs,
    currentDateFnsLocale: dateFnsLocaleMap[currentLang.value] || enUS,
  };
}
